import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IInvoicePostInfo } from '../../models/i-invoice-post-info';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
  standalone: false,
  selector: 'ui-invoice-post-address',
  templateUrl: './ui-invoice-post-address.component.html',
  styleUrls: ['./ui-invoice-post-address.component.scss']
})
export class UiInvoicePostAddressComponent implements OnInit {

  public postInfoForm: FormGroup;

  @Input() postInfo: IInvoicePostInfo;
  @Input() smallLabel: boolean = false;
  @Output() onPostAddressUpdated = new EventEmitter<IInvoicePostInfo>();

  constructor(private _fb: FormBuilder) {
  }

  ngOnInit() {
    this.postInfoForm = this._fb.group({
      invoiceAddress: [''],
      invoicePostNumber: [''],
      invoicePostArea: ['']
    });
    if (this.postInfo) {
      this.postInfoForm.patchValue(this.postInfo);
    }
    this.postInfoForm.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((changes: IInvoicePostInfo) => {
        this.onPostAddressUpdated.emit(changes);
      });
  }

}
